import { Component, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { TranslateService } from '@ngx-translate/core';
import { CookieService } from 'ngx-cookie-service';
import { BaseService } from '../../../providers/base.service';
import { BaseComponent } from '../../shared/base/base.component';

@Component({
  selector: 'app-sla',
  templateUrl: './sla.component.html',
  styleUrls: ['./sla.component.scss']
})
export class SlaComponent extends BaseComponent implements OnInit, OnChanges {
  @Input() userid: any;
  @Input() fromService: boolean;
  data: any;
  loading: boolean;
  error;
  constructor(public service: BaseService,
    public translator: TranslateService,
    public cookieService: CookieService,
    public titleService: Title,) {
    super(service, translator, cookieService, titleService);

  }

  async ngOnInit() {
    await super.ngOnInit();
    if (!this.fromService) {
      this.load();
    }
  }

  load() {
    if (!this.loading) {
      this.loading = true;
      this.data = {};
      this.service.apiCall('api/user/sla', { username: this.userid }).subscribe((result: any) => {
        this.data = result;
        this.loading = false;
      }, error => {
        console.error(error);
        this.loading = false;
      });
    }
  }

  createIssue() {
    this.service.apiCall('api/issue/create',
      { type: 'technical.compensation', entity: 'USER', ref: this.userid }).subscribe((result: any) => { }, error => {
        this.error = error.message || error;
      });
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.userid) {
      this.load();
    }
  }

}
